import * as React from "react";
import Box from "@material-ui/core/Box";
import { useQuery } from "react-query";
import { getTos } from "shared/network/article.api";
import Link from "@material-ui/core/Link";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UnauthorizedLayout from "components/layout/UnauthorizedLayout";

const Tos = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { data } = useQuery(["fetchArticleTosQuery"], async () => {
    const { data } = await getTos();
    return data.item;
  });

  if (!data) {
    return <div />;
  }

  return (
    <UnauthorizedLayout title="ÁSZF">
      <Box>
        <Box display="flex" flexDirection="column" width="100%">
          <Box display="flex" flexDirection="column" overflow="auto" maxHeight="500px">
            <div dangerouslySetInnerHTML={{ __html: data?.content ?? "" }} />
          </Box>
        </Box>
        <Box style={{ padding: "24px 0" }}>
          <Link onClick={history.goBack} style={{ cursor: "pointer" }}>
            {t("common:button.back")}
          </Link>
        </Box>
      </Box>
    </UnauthorizedLayout>
  );
};

export default Tos;
